import { useEffect, useState } from 'react';
import { TransportOrderFeedItem } from '../../../domain/transportOrdersFeed';

export const useTransportOrdersSelection = (items: Array<TransportOrderFeedItem>) => {
    const [selectedItems, setSelectedItems] = useState<Record<string, boolean>>({});
    const [selectAll, setSelectAll] = useState(false);

    useEffect(() => {
        const allActionableItems = items.filter(item =>
            item.type === 'toLoad' ||
            item.type === 'toUnload' ||
            item.type === 'toUnloadAndNotYetLoaded'
        );

        const allSelected = allActionableItems.every(item =>
            selectedItems[item.id]
        );

        setSelectAll(allActionableItems.length > 0 && allSelected);
    }, [selectedItems, items])

    const handleSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
        const isChecked = e.target.checked;
        setSelectAll(isChecked);

        const newSelectedItems: Record<string, boolean> = {};
        items.forEach(item => {
            // Only select items that can have their status changed
            const canChangeStatus = item.type === 'toLoad' || 
                                   item.type === 'toUnload' || 
                                   item.type === 'toUnloadAndNotYetLoaded';
            newSelectedItems[item.id] = isChecked && canChangeStatus;
        });

        setSelectedItems(newSelectedItems);
    };

    const handleSelectItem = (id: string, isChecked: boolean) => {
        setSelectedItems((prev) => ({
            ...prev,
            [id]: isChecked
        }));
    };

    const getSelectedItems = () => {
        return items.filter(item => selectedItems[item.id]);
    };

    const resetSelection = () => {
        setSelectedItems({});
    };

    return {
        selectedItems,
        selectAll,
        handleSelectAll,
        handleSelectItem,
        getSelectedItems,
        resetSelection
    };
};
